import DemoModal from "Components/ModalDemo";
import ForgotYourDetailsModal from "Components/ModalForgotYourDetails";

export default {
	"request-a-demo": DemoModal,
	"forgot-your-details": ForgotYourDetailsModal,
};
